import { InformerNameFields } from '../models/informer.model';

/** Nome completo: "Nome Sobrenome, SIGLA" quando a sigla existir. */
export function formatFullNameWithAbbreviation(
  firstName?: string | null,
  lastName?: string | null,
  abbreviation?: string | null
): string {
  const name = `${firstName ?? ''} ${lastName ?? ''}`.trim();
  const abbr = (abbreviation ?? '').trim();

  if (!name) {
    return abbr;
  }

  if (!abbr) {
    return name;
  }

  return `${name}, ${abbr}`;
}

/** Nome de exibição do informador (usa display_name da API quando disponível). */
export function getInformerDisplayName(entity: InformerNameFields): string {
  const fromApi = (entity.display_name ?? '').trim();
  if (fromApi) {
    return fromApi;
  }

  return formatFullNameWithAbbreviation(
    entity.first_name,
    entity.last_name,
    entity.religious_institution_abbreviation
  );
}

/** Pronome + nome completo com sigla, quando houver pronome. */
export function getInformerNameWithTreatment(entity: InformerNameFields): string {
  const name = getInformerDisplayName(entity);
  const pronoun = entity.treatment_pronoun?.name?.trim();

  return pronoun ? `${pronoun} ${name}` : name;
}
